import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  all: (siteId: string, includeDisabled?: boolean) =>
    fetchPages<LocalisationResponse>(
      'localisations',
      `${config.ws.localisation.all}?siteId=${siteId}&includePackages=false${
        includeDisabled !== undefined ? `&includeDisabled=${includeDisabled}` : ''
      }`,
      'GET'
    ),
  packages: (siteId: string) =>
    fetchPages<LocalisationResponse>(
      'localisations',
      `${config.ws.localisation.all}?siteId=${siteId}&includeDisabled=false&includePackages=true`,
      'GET'
    ),
}

export default api
